import { Outlet, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useEffect } from "react";
import { useNoIndex } from "@/hooks/useNoIndex";

export default function DashboardLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  // Belt-and-braces with robots.txt Disallow: also emit a per-page
  // meta robots noindex,nofollow while inside the dashboard.
  useNoIndex();

  useEffect(() => {
    if (!loading && !user) nav("/login?next=/dashboard");
  }, [loading, user, nav]);

  if (loading || !user) return <div className="min-h-screen flex items-center justify-center text-white/60">Loading…</div>;

  return (
    <div className="min-h-screen flex flex-col">
      <header className="fixed top-0 inset-x-0 z-50 glass border-b border-white/10">
        <div className="mx-auto max-w-[1400px] px-6 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="relative w-7 h-7">
              <div className="absolute inset-0 hex gradient-bg" />
              <div className="absolute inset-[2px] hex bg-[#0A0B10] flex items-center justify-center">
                <span className="font-display font-bold text-xs gradient-text">W</span>
              </div>
            </div>
            <span className="font-display font-semibold text-sm">WeAutomate Console</span>
          </Link>
          <div className="flex items-center gap-4">
            <div className="text-xs text-white/50 font-mono uppercase">{user.role}</div>
            <div className="text-sm">{user.name}</div>
            <button onClick={() => { logout(); nav("/"); }} className="text-sm text-white/60 hover:text-white">
              Sign out
            </button>
          </div>
        </div>
      </header>
      <div className="pt-14 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
